import i18n from '../utils/i18n';

export default {
  TICKET_URL: 'https://manage.bizflycloud.vn/ticket/',
  SUPPORT_URL: 'https://docs.bizflycloud.vn/iam',
  USER_CLASSIFICATION: [
    {
      id: 1,
      title: i18n.t('iam.user.joinedProject'),
      value: true,
    },
    {
      id: 2,
      title: i18n.t('iam.user.notJoinedProject'),
      value: false,
    },
  ],
  TYPE_DATETIME: 'HH:mm:ss DD/MM/YYYY',
  METHOD_GROUP: {
    GET: 'Get',
    POST: 'Create',
    PUT: 'Update',
    PATCH: 'Update',
    DELETE: 'Delete',
  },
  NODE_PARENT_INDEX: {
    Get: 1,
    Create: 2,
    Update: 3,
    Delete: 4,
  },
  LIST_NODE_PARENT_INDEX: [1, 2, 3, 4],
};
